<div class="grid-container margin-top margin-bottom-large wrapper">
  @if (loadComplete) {
    <form [formGroup]="form">
      <div class="grid-x grid-margin-x section">
        <div class="cell small-4 medium-3 large-3 bold">
          Step 1:<span class="minor-margin-left minor-margin-right" [ngClass]="{ 'red': form?.get('reportType')?.invalid }">*</span>What are you reporting?
        </div>
        <div class="cell small-4 medium-6 large-6 padding-left">
          <text-loader [run]="reportTypes?.length == 0" [text]="'Loading Reporting Options'" [tickType]="'.'" [interval]="1000"></text-loader>
          @if (reportTypes?.length > 0) {
            <ng-select formControlName="reportType" [items]="reportTypes" bindValue="typeId" bindLabel="description" [placeholder]="" (ngModelChange)="reportTypeChanged($event)"></ng-select>
          }
        </div>
        <div class="cell small-4 medium-3 large-3 padding-left">
          @if (form?.get('reportId')?.value != null && form?.get('reportId')?.value != '') {
            Application #: {{form?.get('reportId')?.value }}
            Application Status: <span class="bold"> {{appStatus}} </span>
          }
        </div>
        <div class="cell small-6 medium-3 large-3 bold">
          Step 2:<span class="minor-margin-left minor-margin-right" [ngClass]="{ 'red' : form?.get('organization')?.invalid }">*</span>Company # reporting for?
        </div>
        <div class="cell small-3 medium-3 large-3 padding-left">
          <input type="text" formControlName="organization" />
        </div>
        <div class="cell small-3 medium-6 large-6 text-align-left">
          @if (auth?.User?.isInternal) {
            <span class="minor-margin-right">
              <button class="button" (click)="searchOrganizations(true)" [disabled]="orgSearchActive?.value == true || form?.get('organization')?.invalid || orgConfirmed" type="button" alt="Search">
                <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
              </button>
            </span>
            <span class="minor-margin-left">
              <button class="button" type="button" (click)="resetOrganization()" [disabled]="orgSearchActive?.value == true || orgConfirmed" alt="Reset">
                <svg-icon icon="icon-reply" class="small gray"></svg-icon>
              </button>
            </span>
          }
          @if (hasFieldNotes('organization')) {
            <span>
              <view-notes [fieldName]="'organization'" [notes]="getFilteredNotes('organization')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            </span>
          }
          <text-loader [run]="orgSearchActive.value == true" [text]="'Searching'" [interval]="1500"></text-loader>
        </div>
        @if (auth?.User?.isInternal) {
          <div class="cell small-6 medium-3 large-3 bold">
            -OR- Company Name reporting for?
          </div>
          <div class="cell small-3 medium-3 large-3 padding-left">
            <input type="text" formControlName="organizationName" />
          </div>
          <div class="cell small-3 medium-6 large-6 text-align-left">
            @if (auth?.User?.isInternal) {
              <span class="minor-margin-right">
                <button class="button" type="button" (click)="searchOrganizations(false)" [disabled]="orgSearchActive?.value || form?.get('organizationName')?.invalid || orgConfirmed" alt="Search">
                  <svg-icon icon="icon-data-lookup" class="small black"></svg-icon>
                </button>
              </span>
              <span class="minor-margin-left">
                <button class="button" type="button" (click)="resetOrganization()" [disabled]="orgSearchActive?.value == true || orgConfirmed" alt="Reset">
                  <svg-icon icon="icon-reply" class="small gray"></svg-icon>
                </button>
              </span>
            }
            @if (hasFieldNotes('organizationName')) {
              <span>
                <view-notes [fieldName]="'organizationName'" [notes]="getFilteredNotes('organizationName')" (notesRequested)="handleNotesRequested($event)"></view-notes>
              </span>
            }
          </div>
        }
        @if (showODNRError) {
          <div class="cell small-12 medium-12 large-12 bold red">
            Compliance Reports cannot be submitted for the Ohio Department of Natural Resources organization.
          </div>
        }
        @if (selectedOrganization != null) {
          <div class="cell small-12 medium-12 large-12 bold">
            Verify the following:
          </div>
          <div class="cell small-6 medium-3 large-3 padding-left-large bold">
            Company Name:
          </div>
          <div class="cell small-6 medium-9 large-9 padding-left">
            {{selectedOrganization?.name}}
          </div>
          <div class="cell small-6 medium-3 large-3 padding-left-large bold">
            RICS Owner #:
          </div>
          <div class="cell small-6 medium-9 large-9 padding-left">
            <span class="margin-right">{{ricsNumber}}</span><span class="bold margin-right">Registered in RICS?</span>@if (selectedOrganization?.hasRegistered) {
            Yes
            }@if (selectedOrganization?.hasRegistered == false) {
            No
          }
        </div>
        <div class="cell small-6 medium-3 large-3 padding-left-large bold">
          RBDMS Owner #:
        </div>
        <div class="cell small-6 medium-9 large-9 padding-left">
          {{rbdmsNumber}}
        </div>
        <div>
          @if (auth.User.isInternal && isSavedLog == false) {
            <button class="button" (click)="confirmOrg()" [disabled]="orgConfirmed">Confirm Organization</button>
          }
        </div>
      }
      @if (selectedOrganization == null && orgSearchActive?.value == false && form?.get('orgSearchRun')?.value == true) {
        <div class="cell small-12 medium-12 large-12 bold red">
          Organization Not Found
        </div>
      }
    </div>
    <hr />
    @if (showReport) {
      @switch (true) {
        @case (reportType == 'LOGD') {
          @if (isSavedLog) {
            <p>Your selected well #: {{apiNumber}}</p>
          }
          <app-electric-logs [logData]="logsData" [savedApp]="application" [organization]="selectedOrganization" [reportType]="selectedReportType"></app-electric-logs>
        }
        @case (reportType == 'PLUG') {
          @if (isSavedLog) {
            <p>Your selected well #: {{apiNumber}}</p>
          }
          <app-plugging-report-submit [logData]="logsData" [savedApp]="application" [applicationState]="applicationState" [organization]="selectedOrganization" [reportType]="selectedReportType"></app-plugging-report-submit>
        }
        @case (reportType == 'F8B') {
          @if (isSavedLog) {
            <p>Your selected well #: {{apiNumber}}</p>
          }
          <app-well-stim-additives-submit [logData]="logsData" [savedApp]="application" [organization]="selectedOrganization" [reportType]="selectedReportType"></app-well-stim-additives-submit>
        }
        @case (reportType == 'F8A') {
          <app-surface-hole-additive-submit [logData]="logsData" [savedApp]="application" [organization]="selectedOrganization" [reportType]="selectedReportType"></app-surface-hole-additive-submit>
        }
        @case (reportType == 'ADS') {
          <as-drilled-plat-submit [application]="application" [applicationState]="applicationState" [organization]="selectedOrganization" [reportType]="selectedReportType" (onDeactivating)="deactivate($event)"></as-drilled-plat-submit>
        }
        @case (reportType == 'F8') {
          <app-preliminary-completion-report-submit [application]="application" [logData]="logsData" [applicationState]="applicationState" [organization]="selectedOrganization" [reportType]="selectedReportType" (onFormationsClicked)="readData($event)"></app-preliminary-completion-report-submit>
        }
        @case (reportType == 'F8F') {
          <app-final-completion-report [application]="application" [logData]="logsData" [applicationState]="applicationState" [organization]="selectedOrganization" [reportType]="selectedReportType"></app-final-completion-report>
        }
        @default {
        }
      }
    }
  </form>
} @else {
  <div class="grid-x">
    <div class="cell small-12 medium-12 large-12">
      <text-loader [text]="'Loading Application'" [run]="!loadComplete" [tickType]="'.'" [interval]="1000"></text-loader>
    </div>
  </div>
}
</div>

